var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_vm.getModuleConfig('external_member_customer_bind.not_register.step_section.enable_step_section') ? _c('div', {
    staticClass: "p-3"
  }, [_c('SharedStep', {
    attrs: {
      "steps": _vm.getModuleConfig('thanks_page.step_section.steps')
    }
  })], 1) : _vm._e(), _vm.getModuleConfig('external_member_customer_bind.not_register.form_title') ? _c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("external_member_customer_bind.not_register.form_title")) + " ")]) : _vm._e(), _vm.getModuleConfig('external_member_customer_bind.not_register.form_desc') ? _c('div', {
    staticClass: "page__desc"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("external_member_customer_bind.not_register.form_desc")) + " ")]) : _vm._e(), _vm.contentData ? _c('div', {
    staticClass: "page__content",
    domProps: {
      "innerHTML": _vm._s(_vm.contentData)
    }
  }) : _vm._e(), _vm._l(_vm.contentImages, function (image) {
    return _c('img', {
      key: image.order,
      staticClass: "w-100",
      attrs: {
        "src": image.image_url
      }
    });
  }), _c('div', {
    staticClass: "page__button s-space-y-4"
  }, [_vm.showRedirectButton ? [_vm.redirectAction ? _c('MemberButton', {
    attrs: {
      "button-style": "s-btn-outline-primary",
      "button-text": _vm.redirectActionConfig.button_text,
      "type": _vm.redirectAction
    }
  }) : _c('SharedButton', {
    staticClass: "s-btn-outline-primary bg-transparent",
    attrs: {
      "disabled": !_vm.redirectActionEnabled
    },
    on: {
      "click": _vm.redirectToIntended
    }
  }, [_vm._v(" " + _vm._s(_vm.redirectActionConfig.button_text) + " ")])] : _vm._e(), _vm.showGoToButton ? _c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('external_member_customer_bind.not_register.go_to_button_text'),
      "button-url": _vm.appendAdditionalParameters(_vm.getModuleConfig('external_member_customer_bind.not_register.go_to_button_url'), _vm.additionalRedirectUrlParemeters),
      "button-style": "s-btn-outline-primary",
      "type": "URL"
    }
  }) : _vm._e(), _vm.showSuccessButton ? _c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('external_member_customer_bind.not_register.button_text'),
      "button-url": _vm.appendAdditionalParameters(_vm.getModuleConfig('external_member_customer_bind.not_register.button_url'), _vm.additionalRedirectUrlParemeters),
      "type": _vm.getModuleConfig('external_member_customer_bind.not_register.button_action')
    }
  }) : _vm._e()], 2)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }